import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {RedEnvelopeFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";

export abstract class ASign extends ABusiness {
    readonly icon = () => h(RedEnvelopeFilled, {style: 'color: #a855f7'});
    readonly title = '报名';
    readonly description = '';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {
            active: [{value: 'sign', label: '报名'}],
            preheating: [{value: 'sign', label: '报名'}],
            finished: []
        }[status]
    }
}